import React  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
const Styles = styled.div`
  margin: 2rem var(--universal-pad) 2rem;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  
  .link {
    grid-row: 1 span;
    text-decoration: none;
    color: inherit;
    position: relative;
    border-radius: var(--border-radius-3);
    overflow: hidden;
    border: 1px solid var(--n-grey-1);
    box-shadow: 0px 23px 40px -13px #00000014;
    display: flex;
    flex-direction: column;
    .base-image {
      width: 100%;
      height: 100%;
      aspect-ratio: 3.6;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        overflow: hidden;
      }
    }
    .on-top {
      width: 100%;
      position: absolute;
      inset: auto 0 0 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        overflow: hidden;
      }
    }
  }
  @media screen and (max-width:850px) {
    grid-template-columns: repeat(1, 1fr);
    margin: 0 1rem 1rem;
    width: calc(100% - 2rem);
    .link {
      .base-image {
        aspect-ratio: 1.3;
      }
    }
  }
`
export default function BannerOneMain18 (props){
  const {data: dataRaw, lan} = props;
  const data = JSON.parse(dataRaw);
  const makeCart1 = (item, className = "link") => {
    let image = item.ImageDesktop;
    if(window.innerWidth < 850){
      image = item.ImageMobile;
    }
    return (
      <Link className={className} to={"/" + lan.filename + item.link}>
        <div className='base-image'>
          <img src={image} alt='banner'/>
        </div>
      </Link>
    )
  }
  return (
    <Styles>
      {makeCart1(data)}
    </Styles>
  )
}

